import React from 'react';

import DropDown from 'components/dropdown';
import HeaderInfo from './headerInfo';

interface ChatHeaderProps {
  name: string;
  isReportOpen: boolean;
  chatId?: string;
  imgUrl?: string;
  setIsReportOpen: (isReportOpen: boolean) => void;
}
const ChatHeader = ({
  name,
  chatId,
  imgUrl,
  isReportOpen,
  setIsReportOpen,
}: ChatHeaderProps) => {
  return (
    <div className="fixed pl-6 pr-2 top-0 w-full bg-white flex justify-between items-center h-[7%] shadow-[0_4px_5px_rgba(171,190,209,0.3)]">
      <HeaderInfo name={name} imgUrl={imgUrl} />
      <DropDown
        id={chatId ? chatId : ''}
        options={[
          {
            icon: <div className="icon-warning  text-[18px]" />,
            action: _ => setIsReportOpen(!isReportOpen),
            title: 'گزارش تخلف',
          },
        ]}
        listWrapperClassName="w-[201px] absolute z-[20px] top-0"
      />
    </div>
  );
};

export default ChatHeader;
